import { Component, OnDestroy, OnInit, Input, ElementRef, Output, EventEmitter, OnChanges, ViewChild } from '@angular/core';
import { MysqlService } from './../../../services/mysql.service';
import { FileUploaderService } from './../../../services/file-uploader-service';
import { DomSanitizer, Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal'
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { environment } from './../../../../environments/environment';
import { FilterSettingsModel, GridComponent, GroupSettingsModel, IFilter, IFilterUI, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-angular-calendars';
import { GlobalFunctionsService } from 'src/app/services/global-functions.service';
import { HotToastService } from '@ngneat/hot-toast';
import { DemoService } from 'src/app/demo.service';
// import { WordpressService } from 'src/app/services/wordpress.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DataUtil } from '@syncfusion/ej2-data';
import { TabsModule } from 'ngx-bootstrap';
import { Clipboard } from '@angular/cdk/clipboard'; // using the clipboard

@Component({
  selector: 'app-woo-promotion-variable-modal',
  templateUrl: './woo-promotion-variable-modal.component.html',
  styleUrls: ['./woo-promotion-variable-modal.component.scss'],
 
})
export class WooPromotionVariableModalComponent implements OnInit, OnChanges {


  @Input() brand_id: number;
  @Input() title: string = 'Upload or Select File';
// as a model vars
  @Input() item_id: number;
  @Input()  closeBtnName: string;
  @Input() list: any[] = [];
  @Input() user_id: number;
  @Input() promotion_id: number;
  @Input() search_model: any;

  @Input() editorID: any;

       // setup as observable?
      //  @Input() item_id?: Observable<any[]>; // impliments on changes.
       @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
       @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
       @Input() item_user_level_id? = '5'; // default to agent just in case
       @Input() item_brand_type_id? = '';
       @Input() show_buttons? = 'no'; // yes | no
       @Input() widget_title? = '';
       @Input() widget_size? = 'full'; // 

       @Input() varible_code_block_type_id? = ''; // Sets what content to show. default is PDF Vars / labels.
       @Input() template_model?: any; // send the subject communication model to set the search paremers for the variable code block grids choosers.
  
       addTypeClick: boolean;





// grid settings
public pageSettings: Object;
public pageOptions = { pageSize: 100 }; 
public filterOptions: FilterSettingsModel;
public formatOptions: Object;
// public filterOptions: FilterSettingsModel;
public filter : IFilter;
public toolbarOptions: ToolbarItems[];
@ViewChild('grid')
public grid: GridComponent;
public groupOptions: GroupSettingsModel;
public templateOptionsDate: IFilterUI;
public elem1: HTMLElement;
public datePickerObj: DatePicker;
initialPage: { pageSize: number; };
activeTab: any;
activeTabId: any;
value: string;

loading: boolean;
// set an event emitter to send back to parent component
@Output() action = new EventEmitter();
@Output() actionImage = new EventEmitter();
@Output() actionVariable = new EventEmitter();
@Output() actionVariable_EditorID = new EventEmitter();
@Output() actionStr = new EventEmitter();
@Output() actionImageQR = new EventEmitter();



@Output('addFileNameFromModal') addFileNameFromModal: EventEmitter<any> = new EventEmitter();
@Output('closeParentModelDefault') closeParentModelDefault: EventEmitter<any> = new EventEmitter();

sessionBrandId: any;
sessionUsername: any;
sessionUserId: any;
currentUserVAR: any;

div: any;
public nav: any;
public body: any;
public container: any;
// Uploader Service Vars
// public title = 'File Upload Manager - Brands';
// public imgUploaded: string;
public tableData: any;
public baseUploadURL =  environment.baseUploadURL_BrandAssets; // no trailing slash // added brand_id to HTML 
sent_brand_id: any;
wrapSettings: { wrapMode: string; };
  sent_promotion_id: number;
  promotion: any;
  promotion_page_html: any;



  woo_page: number; 
  request_query: {
      context?: string;
      page?: number;
      per_page?: number;
      search?: string;
      after?: string;
      before?: string;
      exclude?: Array<any>;
      include?: Array<any>;
      offset?: number;
      // order?: ProductOrder;
      // orderby?: ProductOrderBy | string;
      // orderby?: "id";
      orderby?:  string;
    
      parent?: Array<string>;
      parent_exclude?: Array<string>;
      slug?: string;
      status?: string;
      type?: string;
      sku?: string;
      featured?: boolean;
      category?: string;
      tag?: string;
      shipping_class?: string;
      attribute?: string;
      attribute_term?: string;
      tax_class?: string;
      in_stock?: boolean;
      on_sale?: boolean;
      min_price?: string;
      max_price?: string;
      action_list_type_id?: number;
      order_id?: number;
      job_type_affidavit_type_id?: number;
      action_list_id?:number;
      job_court_type_id?: number;
      meta_query?;
      id?;
  }
  productSlug: string;
  params: { slug: any; };
  woo_ppscoupons: any[];
  woo_ppscoupons_count: number;
  coupon_id: any;
  set_items_per_page: number;
  woo_coupon_code: any;

html_block
  variable_code_blocks_metrix_search_full: Object;
  variable_code_blocks_metrix_search_full_results: any;
  new_data: any;
  system_log_type_data_sectors: any;
  variable_code_job_types: any;
  variable_code_block_insert_types: any;
  dateFormat: string;
  variable_code_blocks_metrix_search_paragraph_templates: any;
  variable_json_code_block: any;
  variables_SSOT_paragraph_Subject: any;
  variables_SSOT_paragraph_Job: any;
  variable_code_blocks_metrix_search_paragraph_templates_job: Object;
  variable_code_blocks_metrix_search_paragraph_templates_attempt: Object;
  variables_SSOT_paragraph_Attempt: any;
  variable_code_blocks_metrix_search_paragraph_templates_report_client: Object;
  variables_SSOT_paragraph_ReportClient: any;


  // ::@ https://dev.to/this-is-angular/search-and-highlight-text-feature-using-angular-l98
  // ::@ https://stackblitz.com/edit/highlighttext-angular?file=src%2Fapp%2Fapp.module.ts
// highligher sample
// title = 'highlight-text';
searchText='';
searchText1=''
text=`<p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim. Aliquam lorem ante, dapibus in, viverra quis, feugiat a, tellus. Phasellus viverra nulla ut metus varius laoreet. Quisque rutrum. Aenean imperdiet. Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies nisi. Nam eget dui. Etiam rhoncus. Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero, sit amet adipiscing sem neque sed ipsum. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem. Maecenas nec odio et ante tincidunt tempus. Donec vitae sapien ut libero venenatis faucibus. Nullam quis ante. Etiam sit amet orci eget eros faucibus tincidunt. Duis leo. Sed fringilla mauris sit amet nibh. Donec sodales sagittis magna. Sed consequat, leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui. Cras ultricies mi eu turpis hendrerit fringilla. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; In ac dui quis mi consectetuer lacinia. Nam pretium turpis et arcu. Duis arcu tortor, suscipit eget, imperdiet nec, imperdiet iaculis, ipsum. Sed aliquam ultrices mauris. Integer ante arcu, accumsan a, consectetuer eget, posuere ut, mauris. Praesent adipiscing. Phasellus ullamcorper ipsum rutrum nunc. Nunc nonummy metus. Vestibulum volutpat pretium libero. Cras id dui. Aenean ut eros et nisl sagittis vestibulum. Nullam nulla eros, ultricies sit amet, nonummy id, imperdiet feugiat, pede. Sed lectus. Donec mollis hendrerit risus. Phasellus nec sem in justo pellentesque facilisis. Etiam imperdiet imperdiet orci. Nunc nec neque.</p>`
  variable_code_blocks_metrix_search_communication_templates_subject: Object;
  variables_communication_Subject: any;
  variable_code_blocks_metrix_search_paragraph_templates_agent: Object;
  variables_SSOT_paragraph_Agent: any;
  variable_code_blocks_metrix_search_communication_templates_job: Object;
  variables_communication_Job: any;
  variable_code_blocks_metrix_search_communication_templates_report_client: Object;
  variables_communication_ReportClient: any;
  variable_code_blocks_metrix_search_communication_templates_attempt: Object;
  variables_communication_Attempt: any;
  variables_communication_Agent: any;
  variable_code_blocks_metrix_search_communication_templates_agent: Object;
  variables_communication_Subject_count: any;
  variables_SSOT_paragraph_Subject_count: number;
  variables_SSOT_paragraph_Job_count: number;
  variables_SSOT_paragraph_Attempt_count: number;
  variables_SSOT_paragraph_ReportClient_count: number;
  variables_SSOT_paragraph_Agent_count: number;
  variables_communication_Job_count: number;
  variables_communication_ReportClient_count: number;
  variables_communication_Attempt_count: number;
  variables_communication_Agent_count: number;
  variable_code_blocks_metrix_search_communication_templates_invoice_client: Object;
  variables_communication_InvoiceClient: any;
  variables_communication_InvoiceClient_count: number;
  variables_communication_ReportClientUser: any;
  variables_communication_ReportClientUser_count: number;
  variable_code_blocks_metrix_search_communication_templates_report_client_user: Object;
  variable_code_blocks_metrix_search_communication_templates_job_owner: Object;
  variables_communication_JobOwner: any;
  variables_communication_JobOwner_count: number;
  variable_code_blocks_metrix_search_communication_templates_user: Object;
  variables_communication_User: any;
  variables_communication_User_count: number;
  variable_code_blocks_metrix_search_communication_templates_recipient: Object;
  variables_communication_Recipient: any;
  variables_communication_Recipient_count: number;
  variable_code_blocks_metrix_search_communication_templates_attend: Object;
  variables_communication_Attend: any;
  variables_communication_Attend_count: number;
  variable_code_blocks_metrix_search_communication_templates_service: Object;
  variables_communication_Service: any;
  variables_communication_Service_count: number;
  variable_code_blocks_metrix_search_email_signature_templates_user: Object;
  variables_email_signature_User: any;
  variables_email_signature_User_count: number;
  variable_code_blocks_metrix_search_email_signature_templates_owner: Object;
  variables_email_signature_Owner: any;
  variables_email_signature_Owner_count: number;
  variable_code_blocks_metrix_search_automation_templates_recipient: Object;
  variables_automation_Recipient: any;
  variables_automation_Recipient_count: number;
  variable_code_blocks_metrix_search_communication_templates_bulk_payments: Object;
  variables_communication_BulkPayments: any;
  variables_communication_BulkPayments_count: number;



constructor(
  private _mysqlService: MysqlService, private route: ActivatedRoute, private router: Router,
  private fileUploader: FileUploaderService, private elem: ElementRef, public bsModalRef: BsModalRef,
  private modelService: BsModalService,
  public gfunc: GlobalFunctionsService,
  public toastr: HotToastService,
  private _demoService: DemoService,
  // private woocommerce: WordpressService, 
  private http: HttpClient,
  private sanitizer: DomSanitizer,     private clipboard: Clipboard, // ciipboard
) { 
// login vars
this.currentUserVAR = JSON.parse(sessionStorage.getItem('currentUser'));
console.log('sessionUserId: ', this.currentUserVAR.user_id );
console.log('sessionUsername: ', this.currentUserVAR.username );
// Set loggind in User Value (USER ID)
this.sessionUserId = this.currentUserVAR.user_id;
this.sessionUsername = this.currentUserVAR.username;
this.sessionBrandId = this.currentUserVAR.brand_id; 
this.addTypeClick = false;
// get the values from the context vars from model sent into the html into .ts
//let context:any = DialogRef.context;
//this.sent_brand_id = context?.brand_id;

// this.sent_brand_id = this.bsModalRef?.content?.brand_id;

this.wrapSettings = { wrapMode: 'Content' };
// syncfusion GRID OPTIONS
this.toolbarOptions = ['Search'];
this.initialPage = { pageSize: 5 };
this.dateFormat = 'dd/MM/yyyy hh:mm a';
this.filterOptions = {
type: 'Menu'
};
// this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
this.formatOptions = {type: 'date', format: 'dd/MM/yyyy'};
// end grid options



}

ngOnChanges(changes): void {
//Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
//Add '${implements OnChanges}' to the class.
this.sent_brand_id = this.brand_id;
this.sent_promotion_id = this.promotion_id;


if (changes.editorID) {
  // deal with asynchronous Observable result
  this.editorID = changes.editorID.currentValue;

}

}

ngOnInit() {
  this.loadList(this.brand_id);
  // this.getPromotion(this.promotion_id); 
 


  this.getSystemLogTypeDataSectors();
  this.getVariableCodeBlockTypes();
  this.getVariableCodeBlockInsertTypes();
  
  // static module shows pdf variables for Shipping Labels
  //   let search_model = {
  //   "is_active": true,
  //   "variable_code_block_type_id": "2",
  //   "job_type_id": "14",
  //   "job_type_location_id": "15",
  //   "job_type_court_id": "37",
  // }

    this.search_model = {
    is_active: 1,
    // job_type_id: res.job_type_id,
    // variable_code_block_type_id: res.variable_code_block_type_id,
    // job_type_location_id: res.job_type_location_id,
    // job_type_court_id: res.job_type_court_id,
    // variable_code_block_insert_type_id: res.variable_code_block_insert_type_id,
    // "variable_code_block_insert_type_id": 2, //pdfs only
    "variable_code_block_insert_type_id": 1, // html
    "variable_code_block_type_id": 1, // Variable

   };

 this.getVariableCodeBlocksSearchFull(this.search_model)


  this.woo_page = 1; // sets the default page to load is one
  this.set_items_per_page = 100; // as defailt.
  // this.request_query = {
  //   // page: this.woo_page + 1,
  //   page: this.woo_page,
  //   orderby: "id",
  //   per_page: this.set_items_per_page,
  //   // per_page: 10 // gets the number of rec
  //   id: this.coupon_id
  //   }; 
  

  // console.log('PromotionID: ' + this.sent_promotion_id)

  // load the promotion
  // this.getPromotion2(this.sent_promotion_id); 

// this.refreshList();
 // this.sent_brand_id = this.brand_id;
       // refresh the upload list
       
       // when model opens
       // this.list.push('I added one here.');



this.html_block ='<div class="widget yellow-bg p-lg text-center"><div class="m-b-md"><i class="fa fa-thumbs-up fa-4x"></i><h1 class="m-xs">520</h1><h3 class="font-bold no-margins">Likes</h3><small>amount</small></div></div>';


// Load the block variables new  -- load all for now.

this.search_model = {
  is_active: 1,
  // job_type_id: res.job_type_id,
  // variable_code_block_type_id: res.variable_code_block_type_id,
  // job_type_location_id: res.job_type_location_id,
  // job_type_court_id: res.job_type_court_id,
  // variable_code_block_insert_type_id: res.variable_code_block_insert_type_id,
  // "variable_code_block_insert_type_id": 2, //pdfs only

 };
 this.getVariableCodeBlocksSearchFull(this.search_model)





}





// Uploader Functions
public uploadBrandImage(brand_id): void {
this.elem.nativeElement.querySelector('#spinner').style.visibility='visible';
let files = this.elem.nativeElement.querySelector('#selectFile').files;
let formData = new FormData();
let file = files[0];
formData.append('selectFile', file, file.name);
this.fileUploader.uploadBrandImage(formData, brand_id)
.pipe(
  this.toastr.observe({
    loading: '... monkey working ...)',
    success: '🚀',
    error: '😡'
 })
 )
.subscribe(res => {
this.toastr.success('File Uploaded Successfully.');
this.dataLoaded(res);
this.refreshList();
});


}


// Uploader Functions
public uploadImage(): void {
this.elem.nativeElement.querySelector('#spinner').style.visibility='visible';
let files = this.elem.nativeElement.querySelector('#selectFile').files;
let formData = new FormData();
let file = files[0];
formData.append('selectFile', file, file.name);
this.fileUploader.uploadImage(formData).subscribe(
res => {
  this.toastr.success('File Uploaded Successfully.')
  this.dataLoaded(res)
  
}
);
}


dataLoaded(data: any): void {
this.elem.nativeElement.querySelector('#spinner').style.visibility='hidden';
// this.imgUploaded = data._body;
this.refreshList();

}

refreshList(): void {
this.fileUploader.getBrandsList(this.brand_id).subscribe(res=> this.displayTableData(res));

}

displayTableData(data: any): void {
// this.tableData = data.json();
this.tableData = data;
}

// end uploader functions


loadList(brand_id): void {
this.fileUploader.getBrandsList(brand_id).subscribe(res=> this.displayTableData(res));

}



public clickOk(filename) {
// tslint:disable-next-line:indent
console.log('Clicked...');
this.loading = true;
// this.action.emit(true); /// << here you can send object  instead of true
console.log('Clicked...' , filename);
// this.action.emit(filename); /// << here you can send object  instead of true


this.addFileNameFromModal.emit('asdfasdfasdfsadfsd');


//  this.closeParentModelDefault.emit();
}


public clickFile(filename) {
// tslint:disable-next-line:indent
this.loading = true;
this.action.emit(filename); /// << here you can send object  instead of true
this.bsModalRef.hide();
}


public insertFile(fileurl) {
// tslint:disable-next-line:indent
this.loading = true;
this.action.emit(fileurl); /// << here you can send object  instead of true
this.bsModalRef.hide();
}


public insertVariable(fileurl) {
  // tslint:disable-next-line:indent
  this.loading = true;
  this.actionVariable.emit(fileurl); /// << here you can send object  instead of true
  this.bsModalRef.hide();
  }



  // changed to model to enable to send the editorID for many Editors on a single page.
  public insertVariable_EditorID(fileurl, editorID) {
    // tslint:disable-next-line:indent
    let variable_model = {
      "fileurl" : fileurl,
      "editorID" : editorID

    }

    this.loading = true;
    // this.actionVariable_EditorID.emit(fileurl); /// << here you can send object  instead of true
    this.actionVariable_EditorID.emit(variable_model); /// << here you can send object  instead of true
    this.bsModalRef.hide();
    }
  


    insertVariableFromModal_EditorID(fileurl, editorID) {
      // tslint:disable-next-line:indent
      let variable_model = {
        "fileurl" : fileurl,
        "editorID" : editorID
  
      }
  
      this.loading = true;
      // this.actionVariable_EditorID.emit(fileurl); /// << here you can send object  instead of true
      this.action.emit(variable_model); /// << here you can send object  instead of true
      this.bsModalRef.hide();
      }


public insertImage(fileurl) {
  // tslint:disable-next-line:indent
  this.loading = true;
  this.actionImage.emit(fileurl); /// << here you can send object  instead of true
  this.bsModalRef.hide();
  }

  public insertImageQR(fileurl) {
    // tslint:disable-next-line:indent
    this.loading = true;
    this.actionImageQR.emit(fileurl); /// << here you can send object  instead of true
    this.bsModalRef.hide();
    }


 public insertStr(fileurl) {
    // tslint:disable-next-line:indent
    this.loading = true;
    this.actionStr.emit(fileurl); /// << here you can send object  instead of true
    this.bsModalRef.hide();
    }


getPromotion(promotion_id) {
  this._demoService.getPromotion(promotion_id).subscribe(
    data => { this.promotion = data; 
    let res = data[0];
    this.promotion_page_html = res.promotion_page_html;
    this.coupon_id = res.woo_coupon_id;

// console.log('this.template_model.job_type_id ' + this.template_model.job_type_id);

          // console.log('Test: ' + this.template_model.job_type_location_id );
          // loop through template model and setup a search modal.
          this.search_model = {};  

            // Count items of brand search to loop through
            let  count_of_brand_items = Object.keys(this.template_model).length;
            // now loop and push to join model
            for(let i=0;i < count_of_brand_items; i++) {
              let res = this.template_model[i];
            
                // // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
                // this.search_model.push({
                //   "is_active": 1,
                //   "job_type_id": res.job_type_id,
                //   // variable_code_block_type_id: '2',
                //   "job_type_location_id": res.job_type_location_id,
                //   "job_type_court_id": res.job_type_court_id,
                //   // variable_code_block_insert_type_id: res.variable_code_block_insert_type_id,
                //   "variable_code_block_insert_type_id": 2, //pdfs only

                //  });

// need to add -- tp the models neing sent from below.

              if(res.variable_code_block_type_id == ''){
                res.variable_code_block_type_id = 2 // sets to PDF type to show by default
              }

                 this.search_model = {
                  is_active: 1,
                  job_type_id: res.job_type_id,
                  variable_code_block_type_id: res.variable_code_block_type_id,
                  job_type_location_id: res.job_type_location_id,
                  job_type_court_id: res.job_type_court_id,
                  // variable_code_block_insert_type_id: res.variable_code_block_insert_type_id,
                  // "variable_code_block_insert_type_id": 2, //pdfs only

                 };


                        // {
                        //   "variable_code_block_type_id": "2",
                        //   "is_active": true
                        // }

            
            } // end loop.
            
          let search_model = this.search_model;
          this.getVariableCodeBlocksSearchFull(this.search_model)



    },
    err => console.error(err),
    () => {
      console.log('done loading promotion');
      this.request_query = {
        // page: this.woo_page + 1,
        page: this.woo_page,
        orderby: "id",
        per_page: this.set_items_per_page,
        // per_page: 10 // gets the number of rec
        id: this.coupon_id
        }; 
      this.getWooPPSCouponData(this.request_query); // now get the coupon code
    
    }
  );
}

// Get the woo coupons
// use thses one to get WOO API.... Directly no generated functions. etc.
getWooPPSCouponData(request_query){
            //   this.productSlug =  ''; // just for now so I can get the id later
            //   // this.productSlug =  'per_page='+100; // just for now so I can get the id later


            //   // MUST PASS THE ID in the model.

            // //   this.request_query = {
            // //     page: 1,
            // //     orderby: "date",
            // //     per_page: this.set_items_per_page,
            // //     // per_page: 10 // gets the number of rec
            // // // action_list_type_id: 1,

            // //     }; 

            // // this.params = {slug:this.productSlug}  
            //   // this.params = {slug: this.request_query }    
            //   this.params = {slug: request_query } 
            //   // single           
            
            //   let wooWebhooksurl:string = this.woocommerce.authenticateApi('GET', this.gfunc.brand_wordpress_URL + '/wp-json/wc/v3/coupons/' + this.coupon_id, request_query);

                        
            //   // let wooppsactionsurl:string = this.woocommerce.authenticateApi('GET', this.brand_wordpress_URL + '/wp-json/wp/v2/pps-action', this.request_query);
            //   // let wooppsactionsurl:string = this.woocommerce.authenticateApi('GET', this.brand_wordpress_URL + '/wp-json/wp/v2/pps-action', this.request_query);
            //   // let wooproducturl:string = this.woocommerce.authenticateApi('GET',  'products', this.params);
            //   // let wooWebhooksurl:string = this.woocommerce.authenticateApi('GET', this.brand_wordpress_URL + '/wp-json/wc/v3/webhooks', this.params);
            //   // wc/v3/customers
            //   this.http.get(wooWebhooksurl)
            //   .pipe(
            //     this.toastr.observe({
            //       loading: '... monkey working ...',
            //       success: '🚀',
            //       error: '-'
            //    })
            //    )
            //   .subscribe((wc_ppscoupons_data:any) => { 
            //   this.woo_ppscoupons = [wc_ppscoupons_data];   // make object.[] - this makes a mulit call single return work in anagular. --wor forboth if remove [] and all coupons call.
            //   this.woo_ppscoupons_count = this.woo_ppscoupons.length; 
            //  this.woo_coupon_code = this.woo_ppscoupons[0].code;
            
            
            //   // this.product = wc_data[0];  
            //   // this.params = {}
            //   // let productvariationurl:string = this.woocommerce.authenticateApi('GET',this.brand_wordpress_URL + '/shop/wp-json/wc/v2/products/'+this.product.id+'/variations',this.params);
            //   // this.http.get(productvariationurl).subscribe((wc_pv_data:any) => {
            //   //     this.productVariations = wc_pv_data;
            //   // this.toastr.success('...coupon data loaded');
            //   });
}



  // santises the html variable saved in the dabase for template output
  // ::@ https://blog.briebug.com/blog/how-do-i-display-html-inside-an-angular-binding
  transform(value) {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }

  // ::@https://stackoverflow.com/questions/29369512/render-html-entities-string-in-html-with-angular properway to do it (decode html special charactors for dispaly)
  // WORKS as I created my own function from this articel == pretty well convers
  transform2(value: any, args?: any): any {
    const doc = new DOMParser().parseFromString(value, 'text/html');
    return doc.documentElement.textContent;
  }

// ::@https://stackblitz.com/edit/angular-bmxbmy?file=src%2Fapp%2Fapp.component.html
  getHtml(html){
    return this.sanitizer.bypassSecurityTrustHtml(html);
}




// GET ALL HTML VARABLES>>> -- Make a form with a search to make it realy easy like grid page....
// Dynamic Variables
getVariableCodeBlocksSearchFull(search_model) {
  // search_model.brand_type_id = 3;
  // search_model.access_level = 5;


  // this.search_model = {
  //   is_active: 1,
  //   // job_type_id: res.job_type_id,
  //   // variable_code_block_type_id: res.variable_code_block_type_id,
  //   // job_type_location_id: res.job_type_location_id,
  //   // job_type_court_id: res.job_type_court_id,
  //   // variable_code_block_insert_type_id: res.variable_code_block_insert_type_id,
  //   // "variable_code_block_insert_type_id": 2, //pdfs only
  //   "variable_code_block_insert_type_id": 1, // html
  //   "variable_code_block_type_id": 1, // Variable

  //  };



  this._demoService.getVariableCodeBlocksSearchFull(search_model).subscribe(
    data => { this.variable_code_blocks_metrix_search_full = data;
     let res = data[0];
      // pass so that the dates are correct in Sync
      // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
     
     
      this.variable_code_blocks_metrix_search_full_results = DataUtil.parse.parseJson(data);
      // this.subject_service_metrix_search_full_results = data;
      this.new_data = this.variable_code_blocks_metrix_search_full_results.slice(0, 2000);

    

    //  this.grid.refresh();
  
      },
      error => {
      console.error('Error Loading !' + error.error);
      console.log(error);
      // return Observable.throw(error);
      }
      );
       

}



clearSearchResults(search_model){
  this.new_data = [];
  this.search_model = {}// set to empty to get all first.
  this.getVariableCodeBlocksSearchFull(this.search_model);
  this.grid.refresh()
  
  }
  
  
  
  getSystemLogTypeDataSectors() {
    this._demoService.getSystemLogTypeDataSectors().subscribe(
       data => { this.system_log_type_data_sectors = data;
      
      },
       err => console.error(err),
       () => console.log('System Log Type')
     );
   }


   getVariableCodeBlockTypes() {
    this._demoService.getVariableCodeBlockTypes().subscribe(
        data => { this.variable_code_job_types = data; },
        err => console.error(err),
        // () => console.log('done loading Trace Types')
      );
    }

    getVariableCodeBlockInsertTypes() {
      this._demoService.getVariableCodeBlockInsertTypes().subscribe(
          data => { this.variable_code_block_insert_types = data; },
          err => console.error(err),
          // () => console.log('done loading Trace Types')
        );
      }


      getVariables_CommunicationTemplates() {

        this.getVariables_CommunicationTemplates_BulkPaymentAndCustom();

        this.getVariables_CommunicationTemplates_SubjectVariables();
        this.getVariables_CommunicationTemplates_JobVariables();
        this.getVariables_CommunicationTemplates_ReportClientVariables();
        this.getVariables_CommunicationTemplates_AttemptVariables();
        this.getVariables_CommunicationTemplates_AgentVariables();
        this.getVariables_CommunicationTemplates_InvoiceClientVariables();
        this.getVariables_CommunicationTemplates_ReportClientUserVariables();
        this.getVariables_CommunicationTemplates_JobOwnerVariables();
        this.getVariables_CommunicationTemplates_UserVariables();
        this.getVariables_CommunicationTemplates_RecipientVariables();
        this.getVariables_CommunicationTemplates_AttendVariables();
        this.getVariables_CommunicationTemplates_ServiceVariables();

        // + Automations
        this.getVariables_AutomationTemplates_RecipientVariables();


      }
      getVariables_ParagraphTemplates() {
        this.getVariables_ParagraphTemplates_SubjectVariables();
        this.getVariables_ParagraphTemplates_JobVariables();
        this.getVariables_ParagraphTemplates_AttemptVariables();
        this.getVariables_ParagraphTemplates_ReportClient();
        this.getVariables_ParagraphTemplates_Agent();

      }


      getVariables_EmailSignatureTemplates() {
        this.getVariables_EmailSignatureTemplates_UserVariables();
        this.getVariables_EmailSignatureTemplates_OwnerVariables();

      }


      getVariables_ParagraphTemplates_SubjectVariables() {
        // search_model.brand_type_id = 3;
        // search_model.access_level = 5;
      
      
     let search_model = {
          is_active: 1,
          // job_type_id: res.job_type_id,
          // variable_code_block_type_id: res.variable_code_block_type_id,
          // job_type_location_id: res.job_type_location_id,
          // job_type_court_id: res.job_type_court_id,
          // variable_code_block_insert_type_id: res.variable_code_block_insert_type_id,
          // "variable_code_block_insert_type_id": 2, //pdfs only
          "variable_code_block_insert_type_id": 1, // html
          "variable_code_block_type_id": 1, // Variable
          "variable_code_block_id" : 48, // Variables for Paragraphs JSON
          "log_type_data_sector_id" : 20

      
         };
      
      
      
        this._demoService.getVariableCodeBlocksSearchFull(search_model)
        .pipe(
          this.toastr.observe({
            loading: 'Checking...',
            success: ' 🚀..',
            error: '...😡 '
         })
         )
        .subscribe(
          data => { this.variable_code_blocks_metrix_search_paragraph_templates = data;
           let res = data[0];
            // pass so that the dates are correct in Sync
            // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
           
           
                  // this.variable_code_blocks_metrix_search_full_results = DataUtil.parse.parseJson(data);
                  // // this.subject_service_metrix_search_full_results = data;
                  // this.new_data = this.variable_code_blocks_metrix_search_full_results.slice(0, 2000);
 
            this.variable_json_code_block = JSON.parse(res.variable_json_code_block);
            this.variables_SSOT_paragraph_Subject = JSON.parse(res.variable_json_code_block);
            let keys = Object.keys(this.variables_SSOT_paragraph_Subject) // counts the keys in the array
            let count = keys.length;
            this.variables_SSOT_paragraph_Subject_count = count; // counts the subjects.

          //  this.grid.refresh();
          // this.toastr.success('Variables Loaded')
        
            },
            error => {
            console.error('Error Loading !' + error.error);
            console.log(error);
            // return Observable.throw(error);
            }
            );
             
      
      }

      getVariables_ParagraphTemplates_JobVariables() {
        // search_model.brand_type_id = 3;
        // search_model.access_level = 5;
      
      
     let search_model = {
          is_active: 1,
          // job_type_id: res.job_type_id,
          // variable_code_block_type_id: res.variable_code_block_type_id,
          // job_type_location_id: res.job_type_location_id,
          // job_type_court_id: res.job_type_court_id,
          // variable_code_block_insert_type_id: res.variable_code_block_insert_type_id,
          // "variable_code_block_insert_type_id": 2, //pdfs only
          "variable_code_block_insert_type_id": 1, // html
          "variable_code_block_type_id": 1, // Variable
          "variable_code_block_id" : 49, // Variables Job for Paragraphs JSON
          // "log_type_data_sector_id" : 20

      
         };
      
      
      
        this._demoService.getVariableCodeBlocksSearchFull(search_model)
        .pipe(
          this.toastr.observe({
            loading: 'Checking...',
            success: ' 🚀..',
            error: '...😡 '
         })
         )
        .subscribe(
          data => { this.variable_code_blocks_metrix_search_paragraph_templates_job = data;
           let res = data[0];
            // pass so that the dates are correct in Sync
            // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
           
           
                  // this.variable_code_blocks_metrix_search_full_results = DataUtil.parse.parseJson(data);
                  // // this.subject_service_metrix_search_full_results = data;
                  // this.new_data = this.variable_code_blocks_metrix_search_full_results.slice(0, 2000);
 
            this.variables_SSOT_paragraph_Job = JSON.parse(res.variable_json_code_block);
            let keys = Object.keys(this.variables_SSOT_paragraph_Job) // counts the keys in the array
            let count = keys.length;
            this.variables_SSOT_paragraph_Job_count = count; // counts the subjects.
          //  this.grid.refresh();
          // this.toastr.success('Variables Loaded')
        
            },
            error => {
            console.error('Error Loading !' + error.error);
            console.log(error);
            // return Observable.throw(error);
            }
            );
             
      
      }

      getVariables_ParagraphTemplates_AttemptVariables() {
        // search_model.brand_type_id = 3;
        // search_model.access_level = 5;
      
      
     let search_model = {
          is_active: 1,
          // job_type_id: res.job_type_id,
          // variable_code_block_type_id: res.variable_code_block_type_id,
          // job_type_location_id: res.job_type_location_id,
          // job_type_court_id: res.job_type_court_id,
          // variable_code_block_insert_type_id: res.variable_code_block_insert_type_id,
          // "variable_code_block_insert_type_id": 2, //pdfs only
          "variable_code_block_insert_type_id": 1, // html
          "variable_code_block_type_id": 1, // Variable
          "variable_code_block_id" : 50, // code block of json vaiables
          // "log_type_data_sector_id" : 20

      
         };
      
      
      
        this._demoService.getVariableCodeBlocksSearchFull(search_model)
        .pipe(
          this.toastr.observe({
            loading: 'Checking...',
            success: ' 🚀..',
            error: '...😡 '
         })
         )
        .subscribe(
          data => { 
            this.variable_code_blocks_metrix_search_paragraph_templates_attempt = data;
           let res = data[0];
            // pass so that the dates are correct in Sync
            // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
           
           
                  // this.variable_code_blocks_metrix_search_full_results = DataUtil.parse.parseJson(data);
                  // // this.subject_service_metrix_search_full_results = data;
                  // this.new_data = this.variable_code_blocks_metrix_search_full_results.slice(0, 2000);
 
            this.variables_SSOT_paragraph_Attempt = JSON.parse(res.variable_json_code_block);
            let keys = Object.keys(this.variables_SSOT_paragraph_Attempt) // counts the keys in the array
            let count = keys.length;
            this.variables_SSOT_paragraph_Attempt_count = count; // counts the subjects.
          //  this.grid.refresh();
          // this.toastr.success('Variables Loaded')
        
            },
            error => {
            console.error('Error Loading !' + error.error);
            console.log(error);
            // return Observable.throw(error);
            }
            );
             
      
      }



      getVariables_ParagraphTemplates_ReportClient() {
        // search_model.brand_type_id = 3;
        // search_model.access_level = 5;
      
      
     let search_model = {
          is_active: 1,
          // job_type_id: res.job_type_id,
          // variable_code_block_type_id: res.variable_code_block_type_id,
          // job_type_location_id: res.job_type_location_id,
          // job_type_court_id: res.job_type_court_id,
          // variable_code_block_insert_type_id: res.variable_code_block_insert_type_id,
          // "variable_code_block_insert_type_id": 2, //pdfs only
          "variable_code_block_insert_type_id": 1, // html
          "variable_code_block_type_id": 1, // Variable
          "variable_code_block_id" : 51, // Variables Job for Paragraphs JSON
          // "log_type_data_sector_id" : 20

      
         };
      
      
      
        this._demoService.getVariableCodeBlocksSearchFull(search_model)
        .pipe(
          this.toastr.observe({
            loading: 'Checking...',
            success: ' 🚀..',
            error: '...😡 '
         })
         )
        .subscribe(
          data => { this.variable_code_blocks_metrix_search_paragraph_templates_report_client = data;
           let res = data[0];
            // pass so that the dates are correct in Sync
            // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
           
           
                  // this.variable_code_blocks_metrix_search_full_results = DataUtil.parse.parseJson(data);
                  // // this.subject_service_metrix_search_full_results = data;
                  // this.new_data = this.variable_code_blocks_metrix_search_full_results.slice(0, 2000);
 
            this.variables_SSOT_paragraph_ReportClient = JSON.parse(res.variable_json_code_block);
            // this.variables_SSOT_paragraph_Attempt = JSON.parse(res.variable_json_code_block);

            let keys = Object.keys(this.variables_SSOT_paragraph_ReportClient) // counts the keys in the array
            let count = keys.length;
            this.variables_SSOT_paragraph_ReportClient_count = count; // counts the subjects.
          //  this.grid.refresh();
          // this.toastr.success('Variables Loaded')
        
            },
            error => {
            console.error('Error Loading !' + error.error);
            console.log(error);
            // return Observable.throw(error);
            }
            );
             
      
      }

      getVariables_ParagraphTemplates_Agent() {
        // search_model.brand_type_id = 3;
        // search_model.access_level = 5;
      
      
     let search_model = {
          is_active: 1,
          // job_type_id: res.job_type_id,
          // variable_code_block_type_id: res.variable_code_block_type_id,
          // job_type_location_id: res.job_type_location_id,
          // job_type_court_id: res.job_type_court_id,
          // variable_code_block_insert_type_id: res.variable_code_block_insert_type_id,
          // "variable_code_block_insert_type_id": 2, //pdfs only
          "variable_code_block_insert_type_id": 1, // html
          "variable_code_block_type_id": 1, // Variable
          "variable_code_block_id" : 53, // Variables Job for Paragraphs JSON
          // "log_type_data_sector_id" : 20

      
         };
      
      
      
        this._demoService.getVariableCodeBlocksSearchFull(search_model)
        .pipe(
          this.toastr.observe({
            loading: 'Checking...',
            success: ' 🚀..',
            error: '...😡 '
         })
         )
        .subscribe(
          data => { this.variable_code_blocks_metrix_search_paragraph_templates_agent = data;
           let res = data[0];
            // pass so that the dates are correct in Sync
            // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
           
           
                  // this.variable_code_blocks_metrix_search_full_results = DataUtil.parse.parseJson(data);
                  // // this.subject_service_metrix_search_full_results = data;
                  // this.new_data = this.variable_code_blocks_metrix_search_full_results.slice(0, 2000);
 
            this.variables_SSOT_paragraph_Agent = JSON.parse(res.variable_json_code_block);
            let keys = Object.keys(this.variables_SSOT_paragraph_Agent) // counts the keys in the array
            let count = keys.length;
            this.variables_SSOT_paragraph_Agent_count = count; // counts the subjects.
          //  this.grid.refresh();
          // this.toastr.success('Variables Loaded')
        
            },
            error => {
            console.error('Error Loading !' + error.error);
            console.log(error);
            // return Observable.throw(error);
            }
            );
             
      
      }



      getVariables_CommunicationTemplates_SubjectVariables() {
        // search_model.brand_type_id = 3;
        // search_model.access_level = 5;
      
      
     let search_model = {
          is_active: 1,
          // job_type_id: res.job_type_id,
          // variable_code_block_type_id: res.variable_code_block_type_id,
          // job_type_location_id: res.job_type_location_id,
          // job_type_court_id: res.job_type_court_id,
          // variable_code_block_insert_type_id: res.variable_code_block_insert_type_id,
          // "variable_code_block_insert_type_id": 2, //pdfs only
          "variable_code_block_insert_type_id": 1, // html
          "variable_code_block_type_id": 1, // Variable
          "variable_code_block_id" : 52, // Variables for Paragraphs JSON
          "log_type_data_sector_id" : 21 // Comms email and notes

      
         };
      
      
      
        this._demoService.getVariableCodeBlocksSearchFull(search_model)
        .pipe(
          this.toastr.observe({
            loading: 'Checking...',
            success: ' 🚀..',
            error: '...😡 '
         })
         )
        .subscribe(
          data => { this.variable_code_blocks_metrix_search_communication_templates_subject = data;
           let res = data[0];
            // pass so that the dates are correct in Sync
            // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
           
           
                  // this.variable_code_blocks_metrix_search_full_results = DataUtil.parse.parseJson(data);
                  // // this.subject_service_metrix_search_full_results = data;
                  // this.new_data = this.variable_code_blocks_metrix_search_full_results.slice(0, 2000);
 
            this.variable_json_code_block = JSON.parse(res.variable_json_code_block);
            this.variables_communication_Subject = JSON.parse(res.variable_json_code_block);
            
            let keys = Object.keys(this.variable_json_code_block) // counts the keys in the array
            let count = keys.length;
            this.variables_communication_Subject_count = count; // counts the subjects.

          //  this.grid.refresh();
          // this.toastr.success('Variables Loaded')
        
            },
            error => {
            console.error('Error Loading !' + error.error);
            console.log(error);
            // return Observable.throw(error);
            }
            );
             
      
      }
      getVariables_CommunicationTemplates_JobVariables() {
        // search_model.brand_type_id = 3;
        // search_model.access_level = 5;
      
      
     let search_model = {
          is_active: 1,
          // job_type_id: res.job_type_id,
          // variable_code_block_type_id: res.variable_code_block_type_id,
          // job_type_location_id: res.job_type_location_id,
          // job_type_court_id: res.job_type_court_id,
          // variable_code_block_insert_type_id: res.variable_code_block_insert_type_id,
          // "variable_code_block_insert_type_id": 2, //pdfs only
          "variable_code_block_insert_type_id": 1, // html
          "variable_code_block_type_id": 1, // Variable
          "variable_code_block_id" : 54, // Variables for Paragraphs JSON
          "log_type_data_sector_id" : 21 // Comms email and notes

      
         };
      
      
      
        this._demoService.getVariableCodeBlocksSearchFull(search_model)
        .pipe(
          this.toastr.observe({
            loading: 'Checking...',
            success: ' 🚀..',
            error: '...😡 '
         })
         )
        .subscribe(
          data => { this.variable_code_blocks_metrix_search_communication_templates_job = data;
           let res = data[0];
            // pass so that the dates are correct in Sync
            // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
           
           
                  // this.variable_code_blocks_metrix_search_full_results = DataUtil.parse.parseJson(data);
                  // // this.subject_service_metrix_search_full_results = data;
                  // this.new_data = this.variable_code_blocks_metrix_search_full_results.slice(0, 2000);
 
            // this.variable_json_code_block = JSON.parse(res.variable_json_code_block);
            this.variables_communication_Job = JSON.parse(res.variable_json_code_block);
            let keys = Object.keys(this.variables_communication_Job) // counts the keys in the array
            let count = keys.length;
            this.variables_communication_Job_count = count; // counts the subjects.
          //  this.grid.refresh();
          // this.toastr.success('Variables Loaded')
        
            },
            error => {
            console.error('Error Loading !' + error.error);
            console.log(error);
            // return Observable.throw(error);
            }
            );
             
      
      }
      getVariables_CommunicationTemplates_ReportClientVariables() {
        // search_model.brand_type_id = 3;
        // search_model.access_level = 5;
      
      
     let search_model = {
          is_active: 1,
          // job_type_id: res.job_type_id,
          // variable_code_block_type_id: res.variable_code_block_type_id,
          // job_type_location_id: res.job_type_location_id,
          // job_type_court_id: res.job_type_court_id,
          // variable_code_block_insert_type_id: res.variable_code_block_insert_type_id,
          // "variable_code_block_insert_type_id": 2, //pdfs only
          "variable_code_block_insert_type_id": 1, // html
          "variable_code_block_type_id": 1, // Variable
          "variable_code_block_id" : 56, // Variables for Paragraphs JSON
          "log_type_data_sector_id" : 21 // Comms email and notes

      
         };
      
      
      
        this._demoService.getVariableCodeBlocksSearchFull(search_model)
        .pipe(
          this.toastr.observe({
            loading: 'Checking...',
            success: ' 🚀..',
            error: '...😡 '
         })
         )
        .subscribe(
          data => { this.variable_code_blocks_metrix_search_communication_templates_report_client = data;
           let res = data[0];
            // pass so that the dates are correct in Sync
            // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
           
           
                  // this.variable_code_blocks_metrix_search_full_results = DataUtil.parse.parseJson(data);
                  // // this.subject_service_metrix_search_full_results = data;
                  // this.new_data = this.variable_code_blocks_metrix_search_full_results.slice(0, 2000);
 
            // this.variable_json_code_block = JSON.parse(res.variable_json_code_block);
            this.variables_communication_ReportClient = JSON.parse(res.variable_json_code_block);
            let keys = Object.keys(this.variables_communication_ReportClient) // counts the keys in the array
            let count = keys.length;
            this.variables_communication_ReportClient_count = count; // counts the subjects.
          //  this.grid.refresh();
          // this.toastr.success('Variables Loaded')
        
            },
            error => {
            console.error('Error Loading !' + error.error);
            console.log(error);
            // return Observable.throw(error);
            }
            );
             
      
      }
      getVariables_CommunicationTemplates_AttemptVariables() {
        // search_model.brand_type_id = 3;
        // search_model.access_level = 5;
      
      
     let search_model = {
          is_active: 1,
          // job_type_id: res.job_type_id,
          // variable_code_block_type_id: res.variable_code_block_type_id,
          // job_type_location_id: res.job_type_location_id,
          // job_type_court_id: res.job_type_court_id,
          // variable_code_block_insert_type_id: res.variable_code_block_insert_type_id,
          // "variable_code_block_insert_type_id": 2, //pdfs only
          "variable_code_block_insert_type_id": 1, // html
          "variable_code_block_type_id": 1, // Variable
          "variable_code_block_id" : 55, // Variables for Paragraphs JSON
          "log_type_data_sector_id" : 21 // Comms email and notes

      
         };
      
      
      
        this._demoService.getVariableCodeBlocksSearchFull(search_model)
        .pipe(
          this.toastr.observe({
            loading: 'Checking...',
            success: ' 🚀..',
            error: '...😡 '
         })
         )
        .subscribe(
          data => { this.variable_code_blocks_metrix_search_communication_templates_attempt = data;
           let res = data[0];
            // pass so that the dates are correct in Sync
            // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
           
           
                  // this.variable_code_blocks_metrix_search_full_results = DataUtil.parse.parseJson(data);
                  // // this.subject_service_metrix_search_full_results = data;
                  // this.new_data = this.variable_code_blocks_metrix_search_full_results.slice(0, 2000);
 
            // this.variable_json_code_block = JSON.parse(res.variable_json_code_block);
            this.variables_communication_Attempt = JSON.parse(res.variable_json_code_block);
            let keys = Object.keys(this.variables_communication_Attempt) // counts the keys in the array
            let count = keys.length;
            this.variables_communication_Attempt_count = count; // counts the subjects.
          //  this.grid.refresh();
          // this.toastr.success('Variables Loaded')
        
            },
            error => {
            console.error('Error Loading !' + error.error);
            console.log(error);
            // return Observable.throw(error);
            }
            );
             
      
      }
      getVariables_CommunicationTemplates_AgentVariables() {
        // search_model.brand_type_id = 3;
        // search_model.access_level = 5;
      
      
     let search_model = {
          is_active: 1,
          // job_type_id: res.job_type_id,
          // variable_code_block_type_id: res.variable_code_block_type_id,
          // job_type_location_id: res.job_type_location_id,
          // job_type_court_id: res.job_type_court_id,
          // variable_code_block_insert_type_id: res.variable_code_block_insert_type_id,
          // "variable_code_block_insert_type_id": 2, //pdfs only
          "variable_code_block_insert_type_id": 1, // html
          "variable_code_block_type_id": 1, // Variable
          "variable_code_block_id" : 57, // Variables for Paragraphs JSON
          "log_type_data_sector_id" : 21 // Comms email and notes

      
         };
      
      
      
        this._demoService.getVariableCodeBlocksSearchFull(search_model)
        .pipe(
          this.toastr.observe({
            loading: 'Checking...',
            success: ' 🚀..',
            error: '...😡 '
         })
         )
        .subscribe(
          data => { this.variable_code_blocks_metrix_search_communication_templates_agent = data;
           let res = data[0];
            // pass so that the dates are correct in Sync
            // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
           
           
                  // this.variable_code_blocks_metrix_search_full_results = DataUtil.parse.parseJson(data);
                  // // this.subject_service_metrix_search_full_results = data;
                  // this.new_data = this.variable_code_blocks_metrix_search_full_results.slice(0, 2000);
 
            // this.variable_json_code_block = JSON.parse(res.variable_json_code_block);
            this.variables_communication_Agent = JSON.parse(res.variable_json_code_block);
            let keys = Object.keys(this.variables_communication_Agent) // counts the keys in the array
            let count = keys.length;
            this.variables_communication_Agent_count = count; // counts the subje
          //  this.grid.refresh();
          // this.toastr.success('Variables Loaded')
        
            },
            error => {
            console.error('Error Loading !' + error.error);
            console.log(error);
            // return Observable.throw(error);
            }
            );
             
      
      }
      getVariables_CommunicationTemplates_InvoiceClientVariables() {
        // search_model.brand_type_id = 3;
        // search_model.access_level = 5;
      
      
     let search_model = {
          is_active: 1,
          // job_type_id: res.job_type_id,
          // variable_code_block_type_id: res.variable_code_block_type_id,
          // job_type_location_id: res.job_type_location_id,
          // job_type_court_id: res.job_type_court_id,
          // variable_code_block_insert_type_id: res.variable_code_block_insert_type_id,
          // "variable_code_block_insert_type_id": 2, //pdfs only
          "variable_code_block_insert_type_id": 1, // html
          "variable_code_block_type_id": 1, // Variable
          "variable_code_block_id" : 58, // Variables for Paragraphs JSON
          "log_type_data_sector_id" : 21 // Comms email and notes

      
         };
      
      
      
        this._demoService.getVariableCodeBlocksSearchFull(search_model)
        .pipe(
          this.toastr.observe({
            loading: 'Checking...',
            success: ' 🚀..',
            error: '...😡 '
         })
         )
        .subscribe(
          data => { this.variable_code_blocks_metrix_search_communication_templates_invoice_client = data;
           let res = data[0];
            // pass so that the dates are correct in Sync
            // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
           
           
                  // this.variable_code_blocks_metrix_search_full_results = DataUtil.parse.parseJson(data);
                  // // this.subject_service_metrix_search_full_results = data;
                  // this.new_data = this.variable_code_blocks_metrix_search_full_results.slice(0, 2000);
 
            // this.variable_json_code_block = JSON.parse(res.variable_json_code_block);
            this.variables_communication_InvoiceClient = JSON.parse(res.variable_json_code_block);
            let keys = Object.keys(this.variables_communication_InvoiceClient) // counts the keys in the array
            let count = keys.length;
            this.variables_communication_InvoiceClient_count = count; // counts the subje
          //  this.grid.refresh();
          // this.toastr.success('Variables Loaded')
        
            },
            error => {
            console.error('Error Loading !' + error.error);
            console.log(error);
            // return Observable.throw(error);
            }
            );
             
      
      }
      getVariables_CommunicationTemplates_ReportClientUserVariables() {
        // search_model.brand_type_id = 3;
        // search_model.access_level = 5;
      
      
     let search_model = {
          is_active: 1,
          // job_type_id: res.job_type_id,
          // variable_code_block_type_id: res.variable_code_block_type_id,
          // job_type_location_id: res.job_type_location_id,
          // job_type_court_id: res.job_type_court_id,
          // variable_code_block_insert_type_id: res.variable_code_block_insert_type_id,
          // "variable_code_block_insert_type_id": 2, //pdfs only
          "variable_code_block_insert_type_id": 1, // html
          "variable_code_block_type_id": 1, // Variable
          "variable_code_block_id" : 59, // Variables for Paragraphs JSON
          "log_type_data_sector_id" : 21 // Comms email and notes

      
         };
      
      
      
        this._demoService.getVariableCodeBlocksSearchFull(search_model)
        .pipe(
          this.toastr.observe({
            loading: 'Checking...',
            success: ' 🚀..',
            error: '...😡 '
         })
         )
        .subscribe(
          data => { this.variable_code_blocks_metrix_search_communication_templates_report_client_user = data;
           let res = data[0];
            // pass so that the dates are correct in Sync
            // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
           
           
                  // this.variable_code_blocks_metrix_search_full_results = DataUtil.parse.parseJson(data);
                  // // this.subject_service_metrix_search_full_results = data;
                  // this.new_data = this.variable_code_blocks_metrix_search_full_results.slice(0, 2000);
 
            // this.variable_json_code_block = JSON.parse(res.variable_json_code_block);
            this.variables_communication_ReportClientUser = JSON.parse(res.variable_json_code_block);
            let keys = Object.keys(this.variables_communication_ReportClientUser) // counts the keys in the array
            let count = keys.length;
            this.variables_communication_ReportClientUser_count = count; // counts the subje
          //  this.grid.refresh();
          // this.toastr.success('Variables Loaded')
        
            },
            error => {
            console.error('Error Loading !' + error.error);
            console.log(error);
            // return Observable.throw(error);
            }
            );
             
      
      }
      getVariables_CommunicationTemplates_JobOwnerVariables() {
        // search_model.brand_type_id = 3;
        // search_model.access_level = 5;
      
      
     let search_model = {
          is_active: 1,
          // job_type_id: res.job_type_id,
          // variable_code_block_type_id: res.variable_code_block_type_id,
          // job_type_location_id: res.job_type_location_id,
          // job_type_court_id: res.job_type_court_id,
          // variable_code_block_insert_type_id: res.variable_code_block_insert_type_id,
          // "variable_code_block_insert_type_id": 2, //pdfs only
          "variable_code_block_insert_type_id": 1, // html
          "variable_code_block_type_id": 1, // Variable
          "variable_code_block_id" : 60, // Variables for Paragraphs JSON
          "log_type_data_sector_id" : 21 // Comms email and notes

      
         };
      
      
      
        this._demoService.getVariableCodeBlocksSearchFull(search_model)
        .pipe(
          this.toastr.observe({
            loading: 'Checking...',
            success: ' 🚀..',
            error: '...😡 '
         })
         )
        .subscribe(
          data => { this.variable_code_blocks_metrix_search_communication_templates_job_owner = data;
           let res = data[0];
            // pass so that the dates are correct in Sync
            // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
           
           
                  // this.variable_code_blocks_metrix_search_full_results = DataUtil.parse.parseJson(data);
                  // // this.subject_service_metrix_search_full_results = data;
                  // this.new_data = this.variable_code_blocks_metrix_search_full_results.slice(0, 2000);
 
            // this.variable_json_code_block = JSON.parse(res.variable_json_code_block);
            this.variables_communication_JobOwner = JSON.parse(res.variable_json_code_block);
            let keys = Object.keys(this.variables_communication_JobOwner) // counts the keys in the array
            let count = keys.length;
            this.variables_communication_JobOwner_count = count; // counts the subje
          //  this.grid.refresh();
          // this.toastr.success('Variables Loaded')
        
            },
            error => {
            console.error('Error Loading !' + error.error);
            console.log(error);
            // return Observable.throw(error);
            }
            );
             
      
      }

      getVariables_CommunicationTemplates_BulkPaymentAndCustom() {
        // search_model.brand_type_id = 3;
        // search_model.access_level = 5;
      
      
     let search_model = {
          is_active: 1,
          // job_type_id: res.job_type_id,
          // variable_code_block_type_id: res.variable_code_block_type_id,
          // job_type_location_id: res.job_type_location_id,
          // job_type_court_id: res.job_type_court_id,
          // variable_code_block_insert_type_id: res.variable_code_block_insert_type_id,
          // "variable_code_block_insert_type_id": 2, //pdfs only
          "variable_code_block_insert_type_id": 1, // html
          "variable_code_block_type_id": 1, // Variable
          "variable_code_block_id" : 68, // Variables for Paragraphs JSON
          "log_type_data_sector_id" : 23 // Comms email and notes

      
         };
      
      
      
        this._demoService.getVariableCodeBlocksSearchFull(search_model)
        .pipe(
          this.toastr.observe({
            loading: 'Checking...',
            success: ' 🚀..',
            error: '...😡 '
         })
         )
        .subscribe(
          data => { this.variable_code_blocks_metrix_search_communication_templates_bulk_payments = data;
           let res = data[0];
            // pass so that the dates are correct in Sync
            // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
           
           
                  // this.variable_code_blocks_metrix_search_full_results = DataUtil.parse.parseJson(data);
                  // // this.subject_service_metrix_search_full_results = data;
                  // this.new_data = this.variable_code_blocks_metrix_search_full_results.slice(0, 2000);
 
            // this.variable_json_code_block = JSON.parse(res.variable_json_code_block);
            this.variables_communication_BulkPayments = JSON.parse(res.variable_json_code_block);
            let keys = Object.keys(this.variables_communication_BulkPayments) // counts the keys in the array
            let count = keys.length;
            this.variables_communication_BulkPayments_count = count; // counts the subje
          //  this.grid.refresh();
          // this.toastr.success('Variables Loaded')
        
            },
            error => {
            console.error('Error Loading !' + error.error);
            console.log(error);
            // return Observable.throw(error);
            }
            );
             
      
      }


      getVariables_CommunicationTemplates_UserVariables() {
        // search_model.brand_type_id = 3;
        // search_model.access_level = 5;
      
      
     let search_model = {
          is_active: 1,
          // job_type_id: res.job_type_id,
          // variable_code_block_type_id: res.variable_code_block_type_id,
          // job_type_location_id: res.job_type_location_id,
          // job_type_court_id: res.job_type_court_id,
          // variable_code_block_insert_type_id: res.variable_code_block_insert_type_id,
          // "variable_code_block_insert_type_id": 2, //pdfs only
          "variable_code_block_insert_type_id": 1, // html
          "variable_code_block_type_id": 1, // Variable
          "variable_code_block_id" : 61, // Variables for Paragraphs JSON
          "log_type_data_sector_id" : 21 // Comms email and notes

      
         };
      
      
      
        this._demoService.getVariableCodeBlocksSearchFull(search_model)
        .pipe(
          this.toastr.observe({
            loading: 'Checking...',
            success: ' 🚀..',
            error: '...😡 '
         })
         )
        .subscribe(
          data => { this.variable_code_blocks_metrix_search_communication_templates_user = data;
           let res = data[0];
            // pass so that the dates are correct in Sync
            // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
           
           
                  // this.variable_code_blocks_metrix_search_full_results = DataUtil.parse.parseJson(data);
                  // // this.subject_service_metrix_search_full_results = data;
                  // this.new_data = this.variable_code_blocks_metrix_search_full_results.slice(0, 2000);
 
            // this.variable_json_code_block = JSON.parse(res.variable_json_code_block);
            this.variables_communication_User = JSON.parse(res.variable_json_code_block);
            let keys = Object.keys(this.variables_communication_User) // counts the keys in the array
            let count = keys.length;
            this.variables_communication_User_count = count; // counts the subje
          //  this.grid.refresh();
          // this.toastr.success('Variables Loaded')
        
            },
            error => {
            console.error('Error Loading !' + error.error);
            console.log(error);
            // return Observable.throw(error);
            }
            );
             
      
      }
     
      getVariables_CommunicationTemplates_RecipientVariables() {
        // search_model.brand_type_id = 3;
        // search_model.access_level = 5;
      
      
     let search_model = {
          is_active: 1,
          // job_type_id: res.job_type_id,
          // variable_code_block_type_id: res.variable_code_block_type_id,
          // job_type_location_id: res.job_type_location_id,
          // job_type_court_id: res.job_type_court_id,
          // variable_code_block_insert_type_id: res.variable_code_block_insert_type_id,
          // "variable_code_block_insert_type_id": 2, //pdfs only
          "variable_code_block_insert_type_id": 1, // html
          "variable_code_block_type_id": 1, // Variable
          "variable_code_block_id" : 62, // Variables for Paragraphs JSON
          "log_type_data_sector_id" : 21 // Comms email and notes

      
         };
      
      
      
        this._demoService.getVariableCodeBlocksSearchFull(search_model)
        .pipe(
          this.toastr.observe({
            loading: 'Checking...',
            success: ' 🚀..',
            error: '...😡 '
         })
         )
        .subscribe(
          data => { this.variable_code_blocks_metrix_search_communication_templates_recipient = data;
           let res = data[0];
            // pass so that the dates are correct in Sync
            // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
           
           
                  // this.variable_code_blocks_metrix_search_full_results = DataUtil.parse.parseJson(data);
                  // // this.subject_service_metrix_search_full_results = data;
                  // this.new_data = this.variable_code_blocks_metrix_search_full_results.slice(0, 2000);
 
            // this.variable_json_code_block = JSON.parse(res.variable_json_code_block);
            this.variables_communication_Recipient = JSON.parse(res.variable_json_code_block);
            let keys = Object.keys(this.variables_communication_Recipient) // counts the keys in the array
            let count = keys.length;
            this.variables_communication_Recipient_count = count; // counts the subje
          //  this.grid.refresh();
          // this.toastr.success('Variables Loaded')
        
            },
            error => {
            console.error('Error Loading !' + error.error);
            console.log(error);
            // return Observable.throw(error);
            }
            );
             
      
      }
      getVariables_CommunicationTemplates_AttendVariables() {
        // search_model.brand_type_id = 3;
        // search_model.access_level = 5;
      
      
     let search_model = {
          is_active: 1,
          // job_type_id: res.job_type_id,
          // variable_code_block_type_id: res.variable_code_block_type_id,
          // job_type_location_id: res.job_type_location_id,
          // job_type_court_id: res.job_type_court_id,
          // variable_code_block_insert_type_id: res.variable_code_block_insert_type_id,
          // "variable_code_block_insert_type_id": 2, //pdfs only
          "variable_code_block_insert_type_id": 1, // html
          "variable_code_block_type_id": 1, // Variable
          "variable_code_block_id" : 63, // Variables for Paragraphs JSON
          "log_type_data_sector_id" : 21 // Comms email and notes

      
         };
      
      
      
        this._demoService.getVariableCodeBlocksSearchFull(search_model)
        .pipe(
          this.toastr.observe({
            loading: 'Checking...',
            success: ' 🚀..',
            error: '...😡 '
         })
         )
        .subscribe(
          data => { this.variable_code_blocks_metrix_search_communication_templates_attend = data;
           let res = data[0];
            // pass so that the dates are correct in Sync
            // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
           
           
                  // this.variable_code_blocks_metrix_search_full_results = DataUtil.parse.parseJson(data);
                  // // this.subject_service_metrix_search_full_results = data;
                  // this.new_data = this.variable_code_blocks_metrix_search_full_results.slice(0, 2000);
 
            // this.variable_json_code_block = JSON.parse(res.variable_json_code_block);
            this.variables_communication_Attend = JSON.parse(res.variable_json_code_block);
            let keys = Object.keys(this.variables_communication_Attend) // counts the keys in the array
            let count = keys.length;
            this.variables_communication_Attend_count = count; // counts the subje
          //  this.grid.refresh();
          // this.toastr.success('Variables Loaded')
        
            },
            error => {
            console.error('Error Loading !' + error.error);
            console.log(error);
            // return Observable.throw(error);
            }
            );
             
      
      }

      getVariables_CommunicationTemplates_ServiceVariables() {
        // search_model.brand_type_id = 3;
        // search_model.access_level = 5;
      
      
     let search_model = {
          is_active: 1,
          // job_type_id: res.job_type_id,
          // variable_code_block_type_id: res.variable_code_block_type_id,
          // job_type_location_id: res.job_type_location_id,
          // job_type_court_id: res.job_type_court_id,
          // variable_code_block_insert_type_id: res.variable_code_block_insert_type_id,
          // "variable_code_block_insert_type_id": 2, //pdfs only
          "variable_code_block_insert_type_id": 1, // html
          "variable_code_block_type_id": 1, // Variable
          "variable_code_block_id" : 64, // Variables for Paragraphs JSON
          "log_type_data_sector_id" : 21 // Comms email and notes

      
         };
      
      
      
        this._demoService.getVariableCodeBlocksSearchFull(search_model)
        .pipe(
          this.toastr.observe({
            loading: 'Checking...',
            success: ' 🚀..',
            error: '...😡 '
         })
         )
        .subscribe(
          data => { this.variable_code_blocks_metrix_search_communication_templates_service = data;
           let res = data[0];
            // pass so that the dates are correct in Sync
            // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
           
           
                  // this.variable_code_blocks_metrix_search_full_results = DataUtil.parse.parseJson(data);
                  // // this.subject_service_metrix_search_full_results = data;
                  // this.new_data = this.variable_code_blocks_metrix_search_full_results.slice(0, 2000);
 
            // this.variable_json_code_block = JSON.parse(res.variable_json_code_block);
            this.variables_communication_Service = JSON.parse(res.variable_json_code_block);
            let keys = Object.keys(this.variables_communication_Service) // counts the keys in the array
            let count = keys.length;
            this.variables_communication_Service_count = count; // counts the subje
          //  this.grid.refresh();
          // this.toastr.success('Variables Loaded')
        
            },
            error => {
            console.error('Error Loading !' + error.error);
            console.log(error);
            // return Observable.throw(error);
            }
            );
             
      
      }


      getVariables_EmailSignatureTemplates_UserVariables() {
        // search_model.brand_type_id = 3;
        // search_model.access_level = 5;
      
      
     let search_model = {
          is_active: 1,
          // job_type_id: res.job_type_id,
          // variable_code_block_type_id: res.variable_code_block_type_id,
          // job_type_location_id: res.job_type_location_id,
          // job_type_court_id: res.job_type_court_id,
          // variable_code_block_insert_type_id: res.variable_code_block_insert_type_id,
          // "variable_code_block_insert_type_id": 2, //pdfs only
          "variable_code_block_insert_type_id": 1, // html
          "variable_code_block_type_id": 1, // Variable
          "variable_code_block_id" : 65, // Variables for Paragraphs JSON
          "log_type_data_sector_id" : 22 // Comms email and notes

      
         };
      
      
      
        this._demoService.getVariableCodeBlocksSearchFull(search_model)
        .pipe(
          this.toastr.observe({
            loading: 'Checking...',
            success: ' 🚀..',
            error: '...😡 '
         })
         )
        .subscribe(
          data => { this.variable_code_blocks_metrix_search_email_signature_templates_user = data;
           let res = data[0];
            // pass so that the dates are correct in Sync
            // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
           
           
                  // this.variable_code_blocks_metrix_search_full_results = DataUtil.parse.parseJson(data);
                  // // this.subject_service_metrix_search_full_results = data;
                  // this.new_data = this.variable_code_blocks_metrix_search_full_results.slice(0, 2000);
 
            // this.variable_json_code_block = JSON.parse(res.variable_json_code_block);
            this.variables_email_signature_User = JSON.parse(res.variable_json_code_block);
            let keys = Object.keys(this.variables_email_signature_User) // counts the keys in the array
            let count = keys.length;
            this.variables_email_signature_User_count = count; // counts the subje
          //  this.grid.refresh();
          // this.toastr.success('Variables Loaded')
        
            },
            error => {
            console.error('Error Loading !' + error.error);
            console.log(error);
            // return Observable.throw(error);
            }
            );
             
      
      }
      getVariables_EmailSignatureTemplates_OwnerVariables() {
        // search_model.brand_type_id = 3;
        // search_model.access_level = 5;
      
      
     let search_model = {
          is_active: 1,
          // job_type_id: res.job_type_id,
          // variable_code_block_type_id: res.variable_code_block_type_id,
          // job_type_location_id: res.job_type_location_id,
          // job_type_court_id: res.job_type_court_id,
          // variable_code_block_insert_type_id: res.variable_code_block_insert_type_id,
          // "variable_code_block_insert_type_id": 2, //pdfs only
          "variable_code_block_insert_type_id": 1, // html
          "variable_code_block_type_id": 1, // Variable
          "variable_code_block_id" : 66, // Variables for Paragraphs JSON
          "log_type_data_sector_id" : 22 // Comms email and notes

      
         };
      
      
      
        this._demoService.getVariableCodeBlocksSearchFull(search_model)
        .pipe(
          this.toastr.observe({
            loading: 'Checking...',
            success: ' 🚀..',
            error: '...😡 '
         })
         )
        .subscribe(
          data => { this.variable_code_blocks_metrix_search_email_signature_templates_owner = data;
           let res = data[0];
            // pass so that the dates are correct in Sync
            // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
           
           
                  // this.variable_code_blocks_metrix_search_full_results = DataUtil.parse.parseJson(data);
                  // // this.subject_service_metrix_search_full_results = data;
                  // this.new_data = this.variable_code_blocks_metrix_search_full_results.slice(0, 2000);
 
            // this.variable_json_code_block = JSON.parse(res.variable_json_code_block);
            this.variables_email_signature_Owner = JSON.parse(res.variable_json_code_block);
            let keys = Object.keys(this.variables_email_signature_Owner) // counts the keys in the array
            let count = keys.length;
            this.variables_email_signature_Owner_count = count; // counts the subje
          //  this.grid.refresh();
          // this.toastr.success('Variables Loaded')
        
            },
            error => {
            console.error('Error Loading !' + error.error);
            console.log(error);
            // return Observable.throw(error);
            }
            );
             
      
      }



      getVariables_AutomationTemplates_RecipientVariables() {
        // search_model.brand_type_id = 3;
        // search_model.access_level = 5;
      
      
     let search_model = {
          is_active: 1,
          // job_type_id: res.job_type_id,
          // variable_code_block_type_id: res.variable_code_block_type_id,
          // job_type_location_id: res.job_type_location_id,
          // job_type_court_id: res.job_type_court_id,
          // variable_code_block_insert_type_id: res.variable_code_block_insert_type_id,
          // "variable_code_block_insert_type_id": 2, //pdfs only
          "variable_code_block_insert_type_id": 1, // html
          "variable_code_block_type_id": 1, // Variable
          "variable_code_block_id" : 67, // Variables for Paragraphs JSON
          "log_type_data_sector_id" : 23 // Comms email and notes

      
         };
      
      
      
        this._demoService.getVariableCodeBlocksSearchFull(search_model)
        .pipe(
          this.toastr.observe({
            loading: 'Checking...',
            success: ' 🚀..',
            error: '...😡 '
         })
         )
        .subscribe(
          data => { this.variable_code_blocks_metrix_search_automation_templates_recipient = data;
           let res = data[0];
            // pass so that the dates are correct in Sync
            // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
           
           
                  // this.variable_code_blocks_metrix_search_full_results = DataUtil.parse.parseJson(data);
                  // // this.subject_service_metrix_search_full_results = data;
                  // this.new_data = this.variable_code_blocks_metrix_search_full_results.slice(0, 2000);
 
            // this.variable_json_code_block = JSON.parse(res.variable_json_code_block);
            this.variables_automation_Recipient = JSON.parse(res.variable_json_code_block);
            let keys = Object.keys(this.variables_automation_Recipient) // counts the keys in the array
            let count = keys.length;
            this.variables_automation_Recipient_count = count; // counts the subje
          //  this.grid.refresh();
          // this.toastr.success('Variables Loaded')
        
            },
            error => {
            console.error('Error Loading !' + error.error);
            console.log(error);
            // return Observable.throw(error);
            }
            );
             
      
      }



      myFunctionShowHideAny(subject_id, div_id_starter) {
        var x = document.getElementById(div_id_starter + subject_id);
        if (x.style.display === "none") {
          x.style.display = "block";
        } else {
          x.style.display = "none";
        }
      }



      copyToClipboard_Variable(variable) {
        // const content = document.getElementById(id).innerHTML; // copy all formatting.
        // const content = document.getElementById('note_content_' + id).innerText; // wet to copy text and formatting only
        const content = variable
        this.clipboard.copy(content);
        this,this.toastr.info(content + " Copied")
        // this.copyInGrid('btnTwo', id);
      }


} // end
